import React from "react";
import { Table, TableBody, TableContainer, TableHead, TableRow, Paper, Typography } from "@material-ui/core";
import {AiFillFilePdf} from 'react-icons/ai'
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import { styled } from '@mui/material/styles';

const rows = [
  { slNo: 1, appealNO: '01/2014', description: "I.D. Gupta,Vill.& P.O. Salogra,Teh. & Distt. Solan,H.P. Shimla-9. (Appellant). V/S PIO-cum-State Town Planner, Town & Country Pig, Deptt.,H.P. Shimla-9.", pdfUrl: "https://tcp.hp.gov.in/Application//uploadDocuments/content/1.2014.pdf" },
  { slNo: 2, appealNO: '04/2014', description: "Nisha Sood wlo Umesh Sood, rlo Kotwali Bazzar, Shimla Hotel, Dharamshala District Kangra HP (Appellant). V/S PIO-cum-Town & Country Planner, DivisionalTown and Planning Office, DharamshalaDistrict KangraHP (Respondent)", pdfUrl: "https://tcp.hp.gov.in/Application//uploadDocuments/content/4.2014.pdf" },
  { slNo: 3, appealNO: '08/2014', description: "Om Prakash Garg s/o Bhagat RamVPODurgapur Tehsil and district Shimla HP (Appellant) V/S PIO-cum- Town & Country Planner, Divisional Town and PlanningOffice, Shimla (Respondent)",  pdfUrl: "https://tcp.hp.gov.in/Application//uploadDocuments/content/8.2014.pdf" },
  { slNo: 4, appealNO: '2',  description: "Sh. Pyare LalNegi,Sarpara Niwas,Mehli,Post OfficeMehli,Gusan Road,DistricttShimla(HP) Appellant V/S Town and Country Planner, DivisionalTown Planning Office,Shimla(HP) Respondent", pdfUrl: "https://tcp.hp.gov.in/Application//uploadDocuments/content/9.06.2014_1.pdf" },
  { slNo: 5, appealNO: '2', description: "Sh.Anup KumarS/o Sh.Dev Raj,VPO Shamshi,Tehsii & Distt. Kullu (HP) Appellant. V/S Town &Country Planner, DivisionalTown PlanningOffice,Kullu.Respondent",  pdfUrl: "https://tcp.hp.gov.in/Application//uploadDocuments/content/12.6.2014.pdf" },
  { slNo: 6, appealNO: '12/2014', description: " L.N. Aggarwal, Ex-Director, GSI,(Govt. of India), Bansilal Building, Kotwali Bazar, Dharamsala, District Kangra HP .Appellant V/S  PIO-cum-Town & Country Planner, Divisional Town and Country Planning Office,Dharmashala District Kangra HP .Respondent", pdfUrl: "https://tcp.hp.gov.in/Application//uploadDocuments/content/12.2014.pdf" },
]
const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#1f4a7c",
    color: theme.palette.common.white,
    fontSize: 16
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));
const handlePdfDownload = (pdfUrl) => {
  window.open(pdfUrl);
};

const NotificationTCP = () => {
  return (
    <React.Fragment>
    <TableContainer component={Paper}>
    <Typography variant='h6' style={{margin: '20px'}}>
    Order of 1st Appelate Authority Cum Director TCP
    </Typography>
      <Table aria-label="Sample Table" style={{width: '90%', margin: '30px'}}>
        <TableHead>
          <StyledTableRow style={{background: '#1F4A7C', height: '20px', color: 'white'}}>
            <StyledTableCell style={{color: 'white', border: '1px solid #ffff'}}>SL. No</StyledTableCell>
            <StyledTableCell style={{color: 'white', border: '1px solid #ffff'}}>Appeal No.</StyledTableCell>
            <StyledTableCell style={{color: 'white', border: '1px solid #ffff'}}>Title</StyledTableCell>
            <StyledTableCell style={{color: 'white', border: '1px solid #ffff'}}>Order</StyledTableCell>
          </StyledTableRow>
        </TableHead>
        <TableBody>
          {rows.map((row) => (
            <StyledTableRow key={row.slNo}>
              <StyledTableCell component="th" scope="row">
                {row.slNo}
              </StyledTableCell>
              <StyledTableCell>{row.description}</StyledTableCell>
              <StyledTableCell>{row.date}</StyledTableCell>
              <StyledTableCell onClick={() => handlePdfDownload(row.pdfUrl)}><AiFillFilePdf style={{width: '30px', height: '30px', color:'#f44b55', cursor: 'pointer' }}/></StyledTableCell>
            </StyledTableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
    </React.Fragment>
  );
};

export default NotificationTCP;
